"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateProgress = calculateProgress;
const lodash_1 = __importDefault(require("lodash"));
const types_1 = require("../types");
const subsectionVariant_1 = require("../types/carrierQuestionnaire/subsectionVariant");
const QuestionnaireEngine_1 = require("./external/QuestionnaireEngine");
const questionnaire_1 = require("./questionnaire");
const INFORMATIONAL_SUBSECTION_VARIANTS = [
    subsectionVariant_1.SubsectionVariants.productSummary,
    subsectionVariant_1.SubsectionVariants.priceUpdateWarning,
    subsectionVariant_1.SubsectionVariants.summary,
    subsectionVariant_1.SubsectionVariants.submission,
];
function calculateProgress(questionnaire, answerResolver, progressOffset = 0, timezone, currentDateOverride, isCompleted, landingStepId) {
    let progress;
    if (isCompleted) {
        return 100;
    }
    const questionnaireEngine = QuestionnaireEngine_1.QuestionnaireEngine.from({
        questionnaire,
        answerResolver,
        timezone,
        currentDateOverride,
        language: types_1.Language.en,
    });
    const renderingQuestionnaire = questionnaireEngine.renderingQuestionnaire;
    const allSubsections = (0, questionnaire_1.getAllSubsections)(renderingQuestionnaire);
    const allVisibleSubsections = allSubsections.filter((step) => step.visible);
    const allSubsectionsContributingToProgress = allVisibleSubsections.filter((subsection) => !INFORMATIONAL_SUBSECTION_VARIANTS.includes(subsection.variant ?? subsectionVariant_1.SubsectionVariants.form));
    const completedSubsections = allSubsectionsContributingToProgress.filter((step) => step.completed);
    if (!progressOffset) {
        progress = Math.round((completedSubsections.length / allSubsectionsContributingToProgress.length) * 100);
    }
    else {
        const isLandingStepIdCompleted = completedSubsections.some((step) => step.id === landingStepId);
        const completedSubsectionsBeforeApplicationFill = !isLandingStepIdCompleted ? completedSubsections.length : 0;
        const completedSubsectionsAfterApplicationFill = completedSubsections.length - completedSubsectionsBeforeApplicationFill;
        const allSubsectionsAfterApplicationFill = allSubsectionsContributingToProgress.length - completedSubsectionsBeforeApplicationFill;
        progress = Math.round((completedSubsectionsAfterApplicationFill / allSubsectionsAfterApplicationFill) * (100 - progressOffset) +
            progressOffset);
    }
    if (!lodash_1.default.isFinite(progress))
        progress = 0;
    return progress;
}
